











































































import Component from 'vue-class-component';
import { MasterPage } from '@/components/base/master/master-page';
import ClickOutsCriteriaComponent from './click-outs-criteria.vue';
import * as ent from '@/entities';
import clickOutsApi from '@/api/click-outs.api';
import {whiteLabel} from '@/services/config/config.service';


@Component({
    components: {
        'click-outs-criteria': ClickOutsCriteriaComponent
    }
})
export default class ClickOutsMaster extends MasterPage {
    public items: ent.IClickOutListModel[] = [];

    protected defaultSort: ent.ISort = {
        field: 'clickTime',
        asc: false
    };

    private getModel: ent.IGetClickOutsModel = null;

    get IPVisible(): boolean {
        return whiteLabel.IPVisible;
    }
    get ReferrerVisible(): boolean {
        return whiteLabel.ReferrerVisible;
    }

    get colsCount(): number {
        return this.IPVisible ? 8 : 5;
    }

    public modelChange(model: ent.IGetClickOutsModel) {
        this.getModel = model;
        this.search();
    }

    // todo: refactor -> remove dublication
    protected search() {
        let body: ent.IGetClickOutsModel = {
            ...this.getModel,
             ...this.pageSortParams()
        };

        // this.total = 0;
        // this.items = [];
        this.loading = true;
        return clickOutsApi
            .list(body)
            .then((response: ent.IPaging<any>) => {
                this.loading = false;
                this.items = response.items;
                if (response.total !== null) {
                    this.total = response.total;
                }
            })
            .catch((err) => console.warn(err));
    }
}
